import { useState, useEffect } from 'react';
import './LoadingLogo.css';
import logo from "../assets/cara.jpeg";
import { BeatLoader } from 'react-spinners';
// import { useState, useEffect } from 'react';


function LoadingLogo() {
    const [isLoading, setIsLoading] = useState(true);
  
    useEffect(() => {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 25000); // Set the loading duration in milliseconds
  
      return () => clearTimeout(timer);
    }, []);
  
    return (
      <div className="flex flex-col items-center justify-center py-8 px-4 sm:px-6 lg:px-8 rounded-lg">
        <div className={`logo-spinner${isLoading ? ' flip' : ''}`}>
          <img src={logo} alt="Fusion Tech" className="logo w-24 h-24" />
        </div>
        <div className="mt-4">
          <BeatLoader color="#00c0fd" />
        </div>
      </div>
    );
  }
  
  export default LoadingLogo;